/**
 * Smart back navigation helper.
 *
 * The user expectation when clicking "Retour" is "send me back exactly where
 * I came from" — be it /notifications, /candidats with a specific filter,
 * /pepites, /vivier, /calendrier-immersions, search results, etc.
 *
 * Browser history (`navigate(-1)`) is the most reliable source of truth for
 * "where I came from". We track entry count via window.history.length and
 * fall back to a safe default URL only when there's no history to go back to
 * (e.g. the user landed directly on a deep link).
 */
export function goBack(navigate, fallback = "/candidats") {
    // Detect SPA history entries created since the tab was opened.
    // The very first page load gives us length=1 (just the initial entry);
    // every subsequent navigation increments it.
    if (typeof window !== "undefined" && window.history && window.history.length > 1) {
        navigate(-1);
        return;
    }
    navigate(fallback);
}
